<div>
	<!-- filters -->
	<div class="d-flex justify-content-start my-1">
		<div class="service-subscription-filter-50"></div>
		<div
			class="service-subscription-filter-300 d-flex align-items-start flex-column">
			<div class="mt-auto">Description</div>
			<input
				class="form-control"
				type="text"
				[(ngModel)]="filterDescription"
				placeholder="Description..."
				(keyup)="filterTable()" data-testid="service-subscription-editor-filter-description"/>
		</div>
		<div
			class="service-subscription-filter-300 d-flex align-items-start flex-column">
			<div class="mt-auto">Service</div>
			<select
				class="form-control"
				[(ngModel)]="filterService"
				(change)="filterTable()"
				[disabled]="!companyServices" data-testid="service-subscription-editor-filter-service">
				<option value="-1">Please select</option>
				<option *ngFor="let cs of companyServices" [value]="cs.serviceTypeId">
					{{ cs.serviceName }}
				</option>
			</select>
		</div>
		<div
			class="service-subscription-filter-150 d-flex align-items-start flex-column">
			<div class="mt-auto">Billing Frequency</div>
			<select
				class="form-control"
				[(ngModel)]="filterBillingFrequency"
				(change)="filterTable()"
				[disabled]="!frequencyRows" data-testid="service-subscription-editor-filter-billing-frequency">
				<option value="-1">Please select</option>
				<option *ngFor="let f of frequencyRows" [value]="f.id">
					{{ f.frequencyName }}
				</option>
			</select>
		</div>
		<div
			class="service-subscription-filter-100 d-flex align-items-start flex-column">
			<div class="mt-auto">Starting Month</div>
			<select
				class="form-control W-100"
				[(ngModel)]="filterStartingMonth"
				(change)="filterTable()" data-testid="service-subscription-editor-filter-starting-month">
				<option value="-1">Please select</option>
				<option value="1">January</option>
				<option value="2">February</option>
				<option value="3">March</option>
				<option value="4">April</option>
				<option value="5">May</option>
				<option value="6">June</option>
				<option value="7">July</option>
				<option value="8">August</option>
				<option value="9">September</option>
				<option value="10">October</option>
				<option value="11">November</option>
				<option value="12">December</option>
			</select>
		</div>
		<div
			class="service-subscription-filter-100 d-flex align-items-start flex-column">
			<div class="mt-auto">Starting Day</div>
			<input
				type="number"
				class="form-control W-100"
				[(ngModel)]="filterStartingDay"
				placeholder="Day..."
				(change)="filterTable()"
				(keyup)="filterTable()" data-testid="service-subscription-editor-filter-starting-day-number"/>
		</div>
		<div
			class="service-subscription-filter-100 d-flex align-items-start flex-column">
			<div class="mt-auto">Override?</div>
			<select
				class="form-control W-100"
				[(ngModel)]="filterHasOverride"
				(change)="filterTable()" data-testid="service-subscription-editor-filter-has-override">
				<option value="">Please select</option>
				<option value="Yes">Yes</option>
				<option value="No">No</option>
			</select>
		</div>
		<div class="ml-auto p-2 bd-highlight">
			<button class="btn btn-primary" (click)="addNewService()" data-testid="service-subscription-editor-create-new-subscription">
				Create New Subscription
			</button>
		</div>
	</div>
	<!-- Main Table -->
	<ngx-datatable
		#subscriptionTable
		class="material striped service-edit-subscription-modal-table"
		[rows]="filterRows"
		[headerHeight]="50"
		[footerHeight]="40"
		[columnMode]="'force'"
		[rowHeight]="35"
		[scrollbarV]="true">
		<ngx-datatable-row-detail [rowHeight]="300">
			<ng-template
				let-row="row"
				let-expanded="expanded"
				ngx-datatable-row-detail-template let-rowIndex="rowIndex">
				<div>
					<div>
						<!--sub table-->
						<div
							class="text-primary d-flex justify-content-center py-5"
							*ngIf="!row.rates">
							<i class="fa-duotone fa-spinner-third fa-spin fa-3x"></i>
						</div>
						<div class="row" *ngIf="row.rates">
							<div class="col-11">
								<ngx-datatable
									class="material sub-table-height"
									[rows]="row.rates"
									[headerHeight]="50"
									[footerHeight]="40"
									[columnMode]="'force'"
									[rowHeight]="35"
									[scrollbarV]="true">
									<ngx-datatable-column
										*ngFor="let column of subTableColumns; let i = index"
										name="{{ column.name }}"
										prop="{{ column.prop }}"
										[width]="column.width"
										[cellClass]="getCellClass">
										<ng-template
											ngx-datatable-cell-template
											let-value="value"
											let-row="row"
											*ngIf="column.prop === 'chargeTypeId'">
											<div>
												{{ displayChargeType(value) }}
											</div>
										</ng-template>
										<ng-template
											ngx-datatable-cell-template
											let-value="value"
											let-row="row"
											*ngIf="column.prop === 'serviceCodeId'">
											<div>
												{{ displayServiceCode(value) }}
											</div>
										</ng-template>
										<ng-template
											ngx-datatable-cell-template
											let-value="value"
											let-row="row"
											*ngIf="column.prop === 'isRecurring'">
											<div *ngIf="row.isRecurring != null">
												<span class="text-primary" *ngIf="value"
													>Recurring
												</span>
												<span class="text-warning" *ngIf="!value"
													>Not Recurring</span
												>
											</div>
										</ng-template>
										<ng-template
											ngx-datatable-cell-template
											let-value="value"
											let-row="row"
											*ngIf="column.prop === 'name'" let-rowIdx="rowIndex">
											<div *ngIf="!row.editMode">
												{{ value }}
											</div>
											<div *ngIf="row.editMode">
												<select
													class="form-control service-subscription-filter-250"
													[(ngModel)]="row.editRateId"
													(change)="setRowRate(row)" [attr.data-testid]="'service-subscription-editor-edit-rate-id-' + rowIndex + '-' + i + '-' + rowIdx">
													<option value="-1">Please select</option>
													<option
														*ngFor="let f of rateDropdown"
														[value]="f.rateId">
														{{ f.name }}
													</option>
												</select>
											</div>
										</ng-template>
										<ng-template
											ngx-datatable-cell-template
											let-value="value"
											let-row="row"
											*ngIf="column.prop === 'noteTemplate'" let-rowIdx="rowIndex">
											<div *ngIf="!row.editMode">
												{{ value }}
											</div>
											<div *ngIf="row.editMode && row.editRateId > 0">
												<input
													class="form-control service-subscription-filter-300"
													type="text"
													[(ngModel)]="row.editNoteTemplate" [attr.data-testid]="'service-subscription-editor-edit-note-template-' + rowIndex + '-' + i + '-' + rowIdx"/>
											</div>
										</ng-template>
										<ng-template
											ngx-datatable-cell-template
											let-value="value"
											let-row="row"
											*ngIf="column.prop === 'isEndOfMonth'">
											<div *ngIf="row.isEndOfMonth != null">
												<span class="text-primary" *ngIf="value">Yes</span>
												<span class="text-warning" *ngIf="!value">No</span>
											</div>
										</ng-template>
									</ngx-datatable-column>
									<ngx-datatable-column
										name=""
										[width]="100"
										[sortable]="false"
										[canAutoResize]="false"
										[draggable]="false"
										[resizeable]="false">
										<ng-template
											ngx-datatable-cell-template
											let-value="value"
											let-row="row" let-rowIdx="rowIndex">
											<div *ngIf="!row.editMode">
												<span
													*ngIf="!row.endDate || row.endDate > todaysDate"
													role="button"
													(click)="editModeRate(row)" [attr.data-testid]="'service-subscription-editor-edit-' + rowIndex + '-' + rowIdx">
													<i class="fa-solid fa-pen-to-square fa-lg"
														role="button"
														aria-label="Edit">
													</i>
												</span>
											</div>
											<div *ngIf="row.editMode">
												<span
													class="text-danger mr-1"
													*ngIf="!row.savingChanges && row.rateTypeId"
													role="button"
													(click)="closeAllEditRates()" [attr.data-testid]="'service-subscription-editor-close-' + rowIndex + '-' + rowIdx">
													<i class="fa-solid fa-x fa-lg"
														role="button"
														aria-label="Close">
													</i>
												</span>
												<span
													class="text-primary mx-1"
													*ngIf="!row.savingChanges && row.editRateId > 0"
													role="button"
													(click)="saveRate(row)" [attr.data-testid]="'service-subscription-editor-save-' + rowIndex + '-' + rowIdx">
													<i class="fa-solid fa-floppy-disk fa-lg"
														role="button"
														aria-label="Save">
													</i>
												</span>
												<span
													class="text-danger ml-2"
													*ngIf="!row.savingChanges"
													role="button"
													(click)="archiveRate(row)" [attr.data-testid]="'service-subscription-editor-archive-' + rowIndex + '-' + rowIdx">
													<i class="fa-solid fa-trash fa-lg"
														role="button"
														aria-label="Archive">
													</i>
												</span>
												<span
													class="text-primary ml-1"
													*ngIf="row.savingChanges">
													<i class="fa-duotone fa-spinner-third fa-spin"></i>
												</span>
											</div>
										</ng-template>
									</ngx-datatable-column>
								</ngx-datatable>
							</div>
							<div class="col-1 p-0">
								<button class="btn btn-primary mb-6" (click)="addRate(row)" [attr.data-testid]="'service-subscription-editor-add-rate-' + rowIndex">
									Add Rate
								</button>
								<br />
								<div class="pb-2">
									<label class="mb-0">Company ID</label>
									<br />
									<input
										class="w-75"
										type="text"
										[(ngModel)]="invoiceCompanyId" [attr.data-testid]="'service-subscription-editor-invoice-company-id-' + rowIndex"/>
								</div>
								<button class="btn btn-primary" (click)="generateInvoice(row)" [attr.data-testid]="'service-subscription-editor-generate-invoice-' + rowIndex">
									Generate <br />
									Invoice
								</button>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</ngx-datatable-row-detail>
		<!-- open sub table-->
		<ngx-datatable-column
			[width]="50"
			[resizeable]="false"
			[sortable]="false"
			[draggable]="false"
			[canAutoResize]="false">
			<ng-template
				let-row="row"
				let-expanded="expanded"
				ngx-datatable-cell-template let-rowIndex="rowIndex">
				<a
					href="javascript:void(0)"
					[class.datatable-icon-right]="!expanded"
					[class.datatable-icon-down]="expanded"
					title="Expand/Collapse Row"
					(click)="toggleExpandRow(row)" [attr.data-testid]="'service-subscription-editor-expand-collapse-row-' + rowIndex">
				</a>
			</ng-template>
		</ngx-datatable-column>
		<!-- main table columns-->
		<ngx-datatable-column
			*ngFor="let column of tableColumns; let i = index"
			name="{{ column.name }}"
			prop="{{ column.prop }}"
			[width]="column.width"
			[cellClass]="getCellClass">
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'description'" let-rowIndex="rowIndex">
				<span *ngIf="!row.editMode">
					{{ value }}
				</span>
				<span *ngIf="row.editMode">
					<input
						class="service-subscription-filter-300"
						type="text"
						[(ngModel)]="row.editDescription" [attr.data-testid]="'service-subscription-editor-edit-description-' + i + '-' + rowIndex"/>
				</span>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'serviceTypeIds'" let-rowIndex="rowIndex">
				<span *ngIf="value && companyServices">
					<span *ngIf="!row.editMode">
						{{ displayServices(value, companyServices) }}
					</span>
					<span *ngIf="row.editMode && row.id == 0">
						<ng-select
							class="auto-grow validation-field w-300"
							placeholder="Please select"
							[items]="companyServices"
							bindValue="serviceTypeId"
							appendTo="body"
							bindLabel="serviceName"
							[multiple]="true"
							[selectableGroup]="true"
							[closeOnSelect]="false"
							[(ngModel)]="row.editServiceTypeIds" [attr.data-testid]="'service-subscription-editor-edit-service-type-ids-' + i + '-' + rowIndex">
						</ng-select>
					</span>
				</span>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'startMonth'" let-rowIndex="rowIndex">
				<span *ngIf="!row.editMode">
					{{ displayMonth(value) }}
				</span>
				<span *ngIf="row.editMode">
					<select class="form-control W-100" [(ngModel)]="row.editStartMonth" [attr.data-testid]="'service-subscription-editor-edit-start-month-' + i + '-' + rowIndex">
						<option value="-1">Please select</option>
						<option value="1">January</option>
						<option value="2">February</option>
						<option value="3">March</option>
						<option value="4">April</option>
						<option value="5">May</option>
						<option value="6">June</option>
						<option value="7">July</option>
						<option value="8">August</option>
						<option value="9">September</option>
						<option value="10">October</option>
						<option value="11">November</option>
						<option value="12">December</option>
					</select>
				</span>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'executionTime'" let-rowIndex="rowIndex">
				<span *ngIf="!row.editMode">
					{{ value }}
				</span>
				<span *ngIf="row.editMode">
					<input
						type="Time"
						class="form-control service-subscription-filter-150"
						[(ngModel)]="row.editExecutionTime"
						placeholder="Time..."
						(change)="restrictMinute($event, row)" [attr.data-testid]="'service-subscription-editor-edit-execution-time-' + i + '-' + rowIndex"/>
				</span>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'startDay'" let-rowIndex="rowIndex">
				<span *ngIf="!row.editMode">
					<span *ngIf="row.frequencyId && row.frequencyId != 4">
						{{ displayDay(value, row.frequencyId) }}
					</span>
					<span *ngIf="row.frequencyId && row.frequencyId == 4">
						{{ displayDay(row.startWeekDay, row.frequencyId) }}
					</span>
				</span>
				<span *ngIf="row.editMode">
					<span *ngIf="row.editFrequencyId && row.editFrequencyId != 4">
						<input
							type="number"
							class="form-control service-subscription-filter-100"
							[(ngModel)]="row.editStartDay"
							placeholder="Day..."
							min="1"
							max="31" [attr.data-testid]="'service-subscription-editor-edit-start-day-number-' + i + '-' + rowIndex"/>
					</span>
					<span *ngIf="row.editFrequencyId && row.editFrequencyId == 4">
						<input
							type="number"
							class="form-control service-subscription-filter-100"
							[(ngModel)]="row.editStartWeekDay"
							placeholder="Day..."
							min="1"
							max="7" [attr.data-testid]="'service-subscription-editor-edit-start-week-day-number-' + i + '-' + rowIndex"/>
					</span>
				</span>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'frequencyId'" let-rowIndex="rowIndex">
				<span *ngIf="value && frequencyRows">
					<span *ngIf="!row.editMode">
						{{ displayFrequency(value, frequencyRows) }}
					</span>
					<span *ngIf="row.editMode">
						<select
							class="form-control service-subscription-filter-150"
							[(ngModel)]="row.editFrequencyId"
							(change)="filterTable()" [attr.data-testid]="'service-subscription-editor-edit-frequency-id-' + i + '-' + rowIndex">
							<option value="-1">Please select</option>
							<option *ngFor="let f of frequencyRows" [value]="f.id">
								{{ f.frequencyName }}
							</option>
						</select>
					</span>
				</span>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'isAutoApproved'" let-rowIndex="rowIndex">
				<div *ngIf="!row.editMode">
					<span class="text-primary" *ngIf="value">Yes</span>
					<span class="text-warning" *ngIf="!value">No</span>
				</div>
				<div *ngIf="row.editMode">
					<select
						class="form-control service-subscription-filter-100"
						[(ngModel)]="row.editIsAutoApproved"
						[ngClass]="{
							'text-primary': row.editHasOverride == 'Yes',
							'text-warning': row.editHasOverride == 'No'
						}" [attr.data-testid]="'service-subscription-editor-edit-auto-approved-' + i + '-' + rowIndex">
						<option class="text-primary" value="Yes">Yes</option>
						<option class="text-warning" value="No">No</option>
					</select>
				</div>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'isActive'">
				<div>
					<span class="text-primary" *ngIf="value">Yes</span>
					<span class="text-warning" *ngIf="!value">No</span>
				</div>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === 'startDate'" let-rowIndex="rowIndex">
				<span *ngIf="row.checked">
					<input class="form-control" type="date" [(ngModel)]="row.startDate" [attr.data-testid]="'service-subscription-editor-start-date-' + i + '-' + rowIndex"/>
				</span>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-row="row"
				*ngIf="column.prop === ''" let-rowIndex="rowIndex">
				<span *ngIf="row.isActive">
					<div *ngIf="!row.editMode">
						<span
							*ngIf="!row.endDate || row.endDate > todaysDate"
							role="button"
							(click)="editMode(row)" [attr.data-testid]="'service-subscription-editor-edit-mode-' + i + '-' + rowIndex">
							<i class="fa-solid fa-pen-to-square fa-lg"
								role="button"
								aria-label="Edit">
							</i>
						</span>
					</div>
					<div *ngIf="row.editMode">
						<span
							class="text-danger mr-1"
							*ngIf="!row.savingChanges && row.id != 0"
							role="button"
							(click)="editMode(row)" [attr.data-testid]="'service-subscription-editor-close-edit-mode-' + i + '-' + rowIndex">
							<i class="fa-solid fa-x fa-lg"
								role="button"
								aria-label="Close">
							</i>
						</span>
						<span
							class="text-primary mx-1"
							*ngIf="!row.savingChanges"
							role="button"
							(click)="save(row)" [attr.data-testid]="'service-subscription-editor-save-floppy-disk-' + i + '-' + rowIndex">
							<i class="fa-solid fa-floppy-disk fa-lg"
								role="button"
								aria-label="Save">
							</i>
						</span>
						<span
							class="text-danger ml-1"
							*ngIf="!row.savingChanges"
							role="button"
							(click)="archiveSubscription(row)" [attr.data-testid]="'service-subscription-editor-archive-subscription-' + i + '-' + rowIndex">
							<i class="fa-solid fa-trash fa-lg"
								role="button"
								aria-label="Archive">
							</i>
						</span>
						<span class="text-primary ml-1" *ngIf="row.savingChanges">
							<i class="fa-duotone fa-spinner-third fa-spin"></i>
						</span>
					</div>
				</span>
			</ng-template>
		</ngx-datatable-column>
	</ngx-datatable>
</div>



// WEBPACK FOOTER //
// ./src/app/developer/components/service-subscription-editor/service-subscription-editor.component.html